var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "ma-3 pa-3",
      attrs: {
        column: "",
        "justify-center": "",
        "fill-height": "",
        "text-xs-center": ""
      }
    },
    [
      _c(
        "v-icon",
        {
          staticStyle: { color: "rgba(183, 183, 183, 0.54)" },
          attrs: { size: 70 }
        },
        [_vm._v("folder_open")]
      ),
      _vm._v(" "),
      _c(
        "label",
        {
          staticStyle: { color: "rgba(183, 183, 183, 0.54)" },
          attrs: { for: "" }
        },
        [_vm._v(_vm._s(_vm.$t("LBL_NO_RECORDS_FOUND")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c66eecf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c66eecf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/empty/template.html
// module id = null
// module chunks = 